import { GatsbyBrowser } from 'gatsby';
import Cookies from 'js-cookie';
import * as qs from 'query-string';

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
declare global {
  interface Window {
    optimizely: {
      push: any;
      get: any;
    };
    optimizelyData: any;
    optimizelyActionApplied: boolean | null;
  }
}

const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({
  routerProps: {
    location: { pathname }
  }
}) => {
  if (pathname.includes('/resource-center')) {
    return false;
  }

  return true;
};

const onClientEntry: GatsbyBrowser['onClientEntry'] = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    // @ts-ignore
    await import('intersection-observer');
  }

  const preloadChart = document.createElement('iframe');
  preloadChart.style.display = 'none';
  preloadChart.src = 'https://app.lucidchart.com/documents/preloadChart';

  const preloadChartNewDomain = document.createElement('iframe');
  preloadChartNewDomain.style.display = 'none';
  preloadChartNewDomain.src = 'https://lucid.app/documents/preloadChart';

  const loadPreloadScripts = () => {
    document.getElementsByTagName('body')[0].appendChild(preloadChart);
    document.getElementsByTagName('body')[0].appendChild(preloadChartNewDomain);
    window.removeEventListener('scroll', loadPreloadScripts);
  };
  window.addEventListener('scroll', loadPreloadScripts);
};

const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
  const { href, search, pathname } = window.location;
  const urlParams = qs.parse(search);
  // Set all url params as a cookie if there is a value
  Object.keys(urlParams).map(key => !!urlParams[key] && Cookies.set(key, urlParams[key] as string));
  const {
    utm_source = 'undefined',
    utm_medium = 'undefined',
    utm_campaign = 'undefined',
    utm_term = 'undefined',
    utm_content = 'undefined',
    utm_id = 'undefined',
    gclid = 'undefined'
  } = urlParams;
  if (window.ga) {
    const userId = Cookies.get('userId');
    const initialLandingPage = Cookies.get('initialLandingPage') || undefined;
    const ltAnonymousId = Cookies.get('lt-anonymous-id') || undefined;

    if (userId) {
      window.ga('set', 'userId', userId);
    }

    if (utm_source !== 'undefined' ||
      utm_medium !== 'undefined' ||
      utm_campaign !== 'undefined' ||
      utm_term !== 'undefined' ||
      utm_content !== 'undefined' ||
      utm_id !== 'undefined' ||
      gclid !== 'undefined') {
      Cookies.set('__gtm_referrer', window.document.referrer);
      Cookies.set('__gtm_campaign_url', href);
    }

    window.ga('set', 'location', href);
    window.ga('set', 'page', `${pathname}${search}`);
    window.ga('set', 'dimension1', search || 'undefined');
    window.ga('set', 'dimension2', initialLandingPage  || 'undefined');
    window.ga('set', 'dimension3', ltAnonymousId || 'undefined');
  }

  if (window.dataLayer) {
    window.dataLayer.push({ 'originalLocation': href });
  }

  if (search.includes('showEditLink=1')) {
    window.localStorage.setItem('showEditLink', '1');
  }
};

const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ prevLocation }) => {
  let { pathname } = window.location;
  if (pathname === '/' || pathname === 'pages/') {
    pathname = 'homepage';
  }

  if (window.optimizely) {
    try {
      window.optimizely.push({
        type: 'activate'
      });
    } catch (error) {
      console.error('Unable to report to Optimizely on route change.', error);
    }
  }

  if (
    prevLocation &&
    !(prevLocation as Location).pathname.includes('/contact/')
  ) {
    // set session storage so we can use it on single page marketo form
    try {
      sessionStorage.setItem(
        'previousPageviewId',
        Cookies.get('lt-pageview-id') || ''
      );
      sessionStorage.setItem(
        'prevLocation',
        (prevLocation as Location).pathname
      );
    } catch {
      // no-op
    }
  }
};

export {
  onClientEntry,
  onRouteUpdate,
  onInitialClientRender,
  shouldUpdateScroll
};
